import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { setDefaultGitBranch } from '@/services/git/api';
import { useAuthStoreV1 } from '@/stores/authStore_v1';

interface SetDefaultGitBranchVars {
  gitBranchId: string | null;
}

export function useSetDefaultGitBranch(): UseMutationResult<void, Error, SetDefaultGitBranchVars> {
  const queryClient = useQueryClient();
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id);

  return useMutation({
    mutationFn: ({ gitBranchId }: SetDefaultGitBranchVars) => setDefaultGitBranch(orgId!, gitBranchId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['defaultGitBranch', orgId] });
    },
  });
}
